export default function DataGrid(): any {
  return {
    MuiDataGrid: {
      defaultProps: {
        pinnedColumnsSectionSeparator: "border",
        pinnedRowsSectionSeparator: "border",
      },
      styleOverrides: {
        root: {
          "--DataGrid-rowBorderColor": "hsl(var(--border))",
          backgroundColor: "hsl(var(--background))",
          ".MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
          ".MuiDataGrid-cell:focus-within": {
            outline: "1px solid hsl(var(--ring))",
          },
          ".Mui-highlight": {
            outline: "1px solid hsl(var(--ring))",
          },
          ".MuiDataGrid-columnHeader:focus-within": {
            // don't allow header to be focused
            outline: "none !important",
          },
          borderWidth: 0,
          borderRadius: 0,
          ".MuiDataGrid-iconSeparator": {
            opacity: 0,
          },
        },
        pinnedColumnHeaders: {
          backgroundColor: "hsl(var(--muted))",
        },
        columnHeader: {
          color: "hsl(var(--text-secondary))",
          padding: "0px 15px",
          backgroundColor: "hsl(var(--muted))",
        },
        columnSeparator: {
          opacity: 0,
        },
        iconButtonContainer: {
          display: "none",
        },
        cell: {
          "&.Mui-selected": {
            // without this, highlighted pinned columns background color becomes transparent
            backgroundColor: "hsl(var(--background))",
            backgroundImage:
              "linear-gradient(hsl(var(--primary) / 0.08), hsl(var(--primary) / 0.08))",
            "&:hover": {
              // without this, highlighted pinned columns background color becomes transparent
              backgroundColor: "hsl(var(--background))",
              backgroundImage:
                "linear-gradient(hsl(var(--primary) / 0.08), hsl(var(--primary) / 0.08))",
            },
          },
          padding: "0px 15px",
          border: "none",
        },
        columnHeaderTitle: {
          fontWeight: 400,
        },
        main: {
          height: "100%",
          overflow: "visible",
        },
        pinnedColumns: {
          backgroundColor: "hsl(var(--background))",
        },
        virtualScroller: {
          height: "inherit",
        },
      },
    },
  };
}
